<script lang="ts">
	import { ArrowBack } from "luxedo-icons"

	interface Props {
		onBack: () => void
		children?: import("svelte").Snippet
	}

	let { onBack, children }: Props = $props()
</script>

<div class="flex-row submenu-heading">
	<button onclick={() => onBack()} class="icon back-button">
		<ArrowBack />
	</button>
	{@render children?.()}
</div>

<style>
	.submenu-heading {
		align-items: center;
		height: 4rem;
		margin-bottom: 1rem;
	}

	.back-button {
		height: 2rem;
		margin-right: 0.5rem;
	}

	.back-button > :global(svg) {
		height: 1.5rem;
		width: fit-content;
	}
</style>
